import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { getImageLink } from '../globalUtils';
import useDataStore from '../Data/dataStore';
const emptyPixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
export const WPImage = ({ id, size = 'full', className, priority, circle, onLoad, }) => {
    const imageRef = useRef(null);
    const firstFetchIsReady = useDataStore((state) => state.firstFetchIsReady);
    const [src, setSrc] = useState(emptyPixel);
    const mounted = useRef(false);
    useEffect(() => {
        if (id === undefined)
            return;
        if (!priority) {
            setTimeout(getImageUrl, 20);
            /* if (!mounted.current) {
              setTimeout(getImageUrl);
            } else {
              getImageUrl();
            } */
        }
    }, [firstFetchIsReady]);
    useEffect(() => {
        if (id === undefined)
            return;
        if (priority) {
            setTimeout(getImageUrl, 10);
        }
        mounted.current = true;
    }, [id, size]);
    const getImageUrl = async () => {
        const staticLink = `/images/${id}.webp`;
        try {
            // 1) HEAD the static .webp
            const headRes = await fetch(staticLink, { method: 'HEAD' });
            const contentType = headRes.headers.get('Content-Type') || '';
            // 2) Only if it's a 200 *and* an image MIME type do we bail out
            if (headRes.ok && contentType.startsWith('image/')) {
                console.log('STATIC IMAGE FOUND:', headRes);
                setSrc(staticLink);
                return;
            }
            else {
                console.warn(headRes.ok
                    ? `Not an image (${contentType}) at ${staticLink}`
                    : `HEAD failed (${headRes.status}) for ${staticLink}`);
            }
        }
        catch (e) {
            console.warn(`Could not HEAD ${staticLink}:`, e);
        }
        // 3) Fallback: fetch your dynamic URL
        const url = await getImageLink(id, size);
        setSrc(url);
    };
    const handleOnLoad = () => {
        if (src !== emptyPixel && imageRef.current) {
            imageRef.current.style.opacity = '1';
        }
    };
    return id === undefined ? null : (_jsx("img", { src: src, className: `wp-image${circle ? ' circle' : ''} ${className ?? ''}`, alt: "", onLoad: handleOnLoad, ref: imageRef }, id));
};
